import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "800",
  height: "800",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.207 20.707a1 1 0 0 1 0-1.414L14.5 12 7.207 4.707a1 1 0 0 1 0-1.414l.707-.707a1 1 0 0 1 1.414 0l8.354 8.353a1.5 1.5 0 0 1 0 2.122l-8.354 8.353a1 1 0 0 1-1.414 0l-.707-.707Z",
      fill: "#000"
    }, null, -1)
  ]))]))
}
export default { render };